import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { useAuthProvider, SessionState } from '@askporter/auth-provider';
import { Loading } from '@askporter/component-library';

interface Props extends Omit<RouteProps, 'component'> {
  Component: React.LazyExoticComponent<React.FC<unknown>>;
  publicProps?: Record<string, unknown>;
  privateProps?: Record<string, unknown>;
}
/**
 * A route that needs context around the user authenticated state, and can be used by both authorised and unauthorised
 * users
 */
export const SemiPrivateRoute: React.FC<Props> = ({ Component, publicProps, privateProps, ...props }: Props) => {
  const { sessionState } = useAuthProvider();

  // for the the two invalid (but non refresh) states, we want to let the user see the page (as a guest), only the public
  // props should be passed
  if ([SessionState.illegal, SessionState.invalid].includes(sessionState)) {
    return <Route {...props} render={() => <Component {...publicProps} />} />;
  }
  // when a session is valid we want to pass the private props
  else if (SessionState.valid === sessionState)
    return <Route {...props} render={() => <Component {...privateProps} />} />;

  return <Loading />;
};

export default SemiPrivateRoute;
